<template>
    <div>
        <v-container fluid class="grey-container cta-container" :style="{ 'min-height': '800px', 'background-size': 'contain', 'background-color': '#E6E6E6', 'background-image': 'url(' + getBackground + ')' }">
            <v-container class="contain-width">

                <v-row>
                    <v-col
                            md="6"
                            offset-md="3"
                            class="login-form"
                    >
                        <h1 class="md-display-2 white--text mb-6">{{ $t('headings.Login') }}</h1>
                        <v-card
                                class="mx-auto form-card"
                                outlined
                                v-if="authenticated() === false"
                        >
                            <v-card-text class="text--primary">
                                <ValidationObserver ref="observer">
                                    <v-form v-model="valid" @submit.prevent="handleSubmit">

                                        <ValidationProvider vid="email" :name="$t('labels.Email')" rules="required" v-slot="{ errors }">
                                            <v-text-field
                                                    v-model="email"
                                                    :error-messages="errors[0]"
                                                    :label="$t('labels.Email')"
                                                    required
                                                    autocapitalize="none"
                                            ></v-text-field>
                                        </ValidationProvider>

                                        <ValidationProvider vid="password" :name="$t('labels.Password')" rules="required" v-slot="{ errors }">
                                            <v-text-field
                                                    v-model="password"
                                                    :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                                                    :type="showPassword ? 'text' : 'password'"
                                                    :error-messages="errors[0]"
                                                    :label="$t('labels.Password')"
                                                    required
                                                    autocapitalize="none"
                                                    @click:append="showPassword = !showPassword"
                                            ></v-text-field>
                                        </ValidationProvider>

                                        <div class="d-flex justify-end">
                                            <v-btn tile color="primary" elevation="0" @click="handleSubmit">{{ $t('buttons.Submit') }}</v-btn>
                                        </div>

                                    </v-form>
                                </ValidationObserver>

                                <v-row>
                                    <v-col
                                            md="6"
                                            offset-md="3"
                                    >
                                        <router-link to="/sign-up">{{ $t('links.Sign up') }}</router-link> | <router-link to="/reset-password">{{ $t('links.Reset password') }}</router-link>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
<!--                        <v-card-->
<!--                                class="mx-auto form-card"-->
<!--                                outlined-->
<!--                                v-if="authenticated() === true"-->
<!--                        >-->
<!--                            <v-card-text class="text&#45;&#45;primary">-->

<!--                                <v-btn tile block color="primary" elevation="0" v-if="userIsOrganisation" class="mb-6" @click="navigate('dashboard')">Go to my organisation</v-btn>-->
<!--                                <v-btn tile block color="primary" elevation="0" v-if="userIsOrganisation" @click="navigate('products')">Shop for tags</v-btn>-->
<!--                            </v-card-text>-->
<!--                        </v-card>-->
                    </v-col>

                </v-row>

            </v-container>
        </v-container>
        <Footer />
    </div>
</template>

<script>
    
    import { mapState, mapActions } from 'vuex'
    import { store } from '../store';

    import { extend } from 'vee-validate';
    import { required, email, min } from 'vee-validate/dist/rules';

    import Footer from './Footer'
    import {i18n} from "../i18n";

    // Add the required rule
    extend('required', required);

    // Add the email rule
    extend('email', email);

    export default {
        name: "Login",
        components: {
            'Footer': Footer
        },
        metaInfo() {
          return {
            title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('Login'),
            htmlAttrs: {
              lang: i18n.locale
            }
          }
        },
        data: () => ({
            email: '',
            password: '',
            valid: false,
            showPassword: false,
        }),
        mounted () {
            this.$gtag.pageview({
                page_path: '/login'
            })

            document.getElementById("scrolling-content").scrollTop = 0

            window.prerenderReady = true;
        },
        computed: {
            ...mapState({
              brand: state => state.brand,
              brandName: state => state.brandName
            }),
            getBackground() {
              if (this.brand === 'neotag') {
                return require('@/assets/neotag-background.jpg')
              }
              else {
                return require('@/assets/neotag-background.jpg')
              }
            },
            userIsOrganisation() {
                return store.getters.userHasRole(['organisation'])
            }
        },
        methods: {
            ...mapActions('account', ['login', 'logout']),
            capitalizeFirstLetter(string) {
              return string.charAt(0).toUpperCase() + string.slice(1);
            },
            authenticated () {
                return store.state.authenticated
            },
            navigate (routeName) {
                this.$router.push({name: routeName})
            },
            async handleSubmit () {

                let observer = this.$refs.observer;

                const isValid = await observer.validate();

                if (isValid) {
                    const { email, password } = this;
                    if (email && password) {
                        this.login({ email, password }).then()
                    }
                }

            }
        }
    }
</script>

<style scoped>
    button {
        text-transform: none;
    }
    /*.login-form {*/
    /*    background-color: rgba(0, 0, 0, 0.7);*/
    /*}*/
</style>
